<template>
  <div>
    Dashboard > Add Team Member
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>

</style>
